import { motion } from "framer-motion";
import BookButterfly from "./BookButterfly";

export default function EveChildFigure({ caption, testid = "eve-child-figure", className = "" }) {
    return (
        <motion.figure
            data-testid={testid}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
            className={`relative mx-auto max-w-[240px] text-center sm:max-w-[280px] ${className}`}
        >
            <BookButterfly
                testid="figure-butterfly"
                className="-top-3 left-[8%] w-8 sm:-top-4 sm:w-9"
                delay={1.2}
                restRange={[900, 1500]}
            />
            <img
                src="/assets/eve-child.webp"
                alt="Eve holding her child in the garden"
                data-testid={`${testid}-image`}
                className="book-glow w-full rounded-md border border-[rgba(212,175,55,0.35)]"
            />
            {caption && (
                <figcaption className="font-cormorant mt-5 text-base italic leading-relaxed text-[#b89860] sm:text-lg">
                    {caption}
                </figcaption>
            )}
        </motion.figure>
    );
}
